export default "__VITE_ASSET__C2I2iWv7__"